import service from '@/utils/server';

const modName='/md/configQcResultTimeout/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const update = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/configQcResultTimeout/api/index.js